import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'escape'})
export class EscapePipe implements PipeTransform {
    transform(input: string): string {
        return input ? encodeURIComponent(input) : '';
    }
}